<script lang="ts" generics="ITEM">
    import type {SearchManager} from '../search-manager/search-manager';
    import KpSearchResultInfoDisplay from './KpSearchResultInfoDisplay.svelte';

    export let searchManager: SearchManager<ITEM>;

    $: lastResult = searchManager.getSearchResult$();
</script>

{#if $lastResult}
    <KpSearchResultInfoDisplay totalElements={$lastResult.totalElements} duration={$lastResult.duration}/>
{/if}
